import { FORTA_BLUE, FORTA_WHITE } from '../../../utils/colors';
import { HEADER_HEIGHT } from '../../../constants';

import type { SxProps, Theme } from '@mui/material';

export const HEADER_FIELD_ROW_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const HEADER_FIELD_LABEL_SX: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 700,
  color: FORTA_WHITE,
};

export const HEADER_FIELD_VALUE_SX: SxProps<Theme> = {
  fontSize: '16px',
  color: FORTA_WHITE,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const APP_HEADER_SX: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: HEADER_HEIGHT,
  padding: { xs: '25px 24px', sm: '25px 60px' },
  boxSizing: 'border-box',
  backgroundColor: FORTA_BLUE.light1,
  position: 'relative',
  zIndex: 9,
};

export const HEADER_TITLE_AREA_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
};

export const HEADER_TITLE_ROW_SX: SxProps<Theme> = {
  ml: { xs: 6, sm: 2, md: 0 },
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'flex-start', sm: 'center' },
};

export const HEADER_TITLE_SX: SxProps<Theme> = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const HEADER_ID_BADGE_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  backgroundColor: FORTA_WHITE,
  borderRadius: '5px',
  mt: 0.5,
  padding: '0.3em 0.6em',
  ml: { xs: 0, sm: 2 },
};

export const HEADER_ID_TEXT_SX: SxProps<Theme> = {
  fontWeight: 'bold',
  letterSpacing: 2,
};

export const HEADER_METADATA_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  ml: { xs: 6, sm: 2, md: 0 },
};

export const HEADER_BAY_WRAPPER_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const HEADER_BAY_BADGE_SX: SxProps<Theme> = {
  fontSize: '14px',
  color: FORTA_WHITE,
  px: 1,
  mt: 0.5,
  borderRadius: '16px',
  backgroundColor: FORTA_BLUE.primary,
};

export const HEADER_ACTIONS_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 1, sm: 2 },
};

export const TRANSLATION_DISCLAIMER_SX: SxProps<Theme> = {
  fontSize: '12px',
  color: FORTA_WHITE,
  width: '200px',
  mr: -2,
};

export const LANGUAGE_SWITCHER_SX: SxProps<Theme> = {
  '.MuiSelect-select': {
    color: 'common.black',
  },
};

export const PROFILE_BUTTON_SX: SxProps<Theme> = {
  p: 0,
};

export const FALLBACK_AVATAR_SX: SxProps<Theme> = {
  backgroundColor: FORTA_BLUE.primary,
  width: 40,
  height: 40,
  borderRadius: '50%',
};

export const QUESTIONNAIRE_HEADER_WRAPPER_SX: SxProps<Theme> = {
  ml: { xs: 6, sm: 2, md: 0 },
  mr: { xs: 2, md: 4 },
  flex: 1,
  minWidth: 0,
};

export const AVATAR_IMAGE_STYLE = {
  width: 40,
  height: 40,
  borderRadius: '50%',
};

export const QUESTIONNAIRE_HEADER_CONTAINER_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: { xs: 2, md: 6 },
  width: '100%',
};

export const QUESTIONNAIRE_HEADER_TITLE_SX: SxProps<Theme> = {
  flex: { xs: 1, md: 'none' },
  minWidth: 0,
  whiteSpace: { xs: 'normal', md: 'nowrap' },
  overflow: { xs: 'visible', md: 'hidden' },
  textOverflow: { xs: 'clip', md: 'ellipsis' },
  wordBreak: 'break-word',
};

export const QUESTIONNAIRE_HEADER_MOBILE_ID_WRAPPER_SX: SxProps<Theme> = {
  display: { xs: 'flex', md: 'none' },
  flexShrink: 0,
};

export const QUESTIONNAIRE_HEADER_DESKTOP_GRID_SX: SxProps<Theme> = {
  display: { xs: 'none', md: 'grid' },
  gridTemplateColumns: 'auto auto',
  columnGap: 6,
  rowGap: 0.5,
};

export const QUESTIONNAIRE_HEADER_FIELD_ROW_SX: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'baseline',
};

export const QUESTIONNAIRE_HEADER_FIELD_LABEL_SX: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 700,
  color: FORTA_WHITE,
  mr: 1,
};

export const QUESTIONNAIRE_HEADER_FIELD_VALUE_SX: SxProps<Theme> = {
  fontSize: '14px',
  color: FORTA_WHITE,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
